var viewer_rtlignore_default = {
  "gallery_container": "c83N2",
  "imageTitleContainer": "X898c",
  "clickableItem": "l40Po",
  "prerender": "_2fjkU",
  "expandButton": "DoMX3",
  "itemContainer": "hu9Uk",
  "expandIcon": "LQrAJ",
  "itemOverlay": "DkYaG",
  "imageTitle": "pXF4T",
  "pointer": "S7vks",
  "fadeIn": "_4VKci",
  "changing_background": "Zv5XM"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
